module.exports = __webpack_public_path__ + "static/media/conheca-joinville.aab6f256.webp";